import { render } from "./BattlesGameBoxes.vue?vue&type=template&id=1b78b1f8&scoped=true"
import script from "./BattlesGameBoxes.vue?vue&type=script&lang=js"
export * from "./BattlesGameBoxes.vue?vue&type=script&lang=js"

import "./BattlesGameBoxes.vue?vue&type=style&index=0&id=1b78b1f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b78b1f8"]])

export default __exports__